// extracted by mini-css-extract-plugin
export default {"info":"informationIcon_info__91lSa"};